


































































import { Vue, Component } from 'vue-property-decorator';
import { $eventBus } from '@/eventBus';

@Component
export default class BaseModal extends Vue {

  show: boolean = false;


  open() {
    this.show = true;
  }
  close() {
    this.show = false;
  }

  mounted() {
    $eventBus.$on('closeModals', this.close);
  }
  beforeDestroy() {
    $eventBus.$off('closeModals', this.close);
  }
}
